import { DataBean } from "../../DataBean";


export class HealthDisabilityAccount extends DataBean {

    public async getHealthDisabilityAccountCatalog(acc: any,Date :any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthDisabilityAccountCatalog_Number_java.util.Date", [acc,Date ]);
    }
 public async addHealthDisabilityAccount(acc: any,idHealthDisabilityType:any,fromDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.health.HealthDisabilityAccount_addHealthDisabilityAccount_Number_Number_java.util.Date_Number", [acc,idHealthDisabilityType,fromDate,idEmployee]);
    }

}